import { Action, createReducer, on } from '@ngrx/store';

import {
  deleteSubscriptionPlan,
  editSubscriptionPlan,
  loadSubscriptionPlans,
  paginateSubscriptionPlans,
} from 'src/actions/subscription/subscription.action';

export const initialState: any = {
  fetching: false,
  data: {
    plans: [],
    totalDocuments: 0,
  },
};

const subscriptionPlansReducer = createReducer(
  initialState,
  on(loadSubscriptionPlans, (state, response) => ({
    ...state,
    data: {
      ...state.data,
      plans: response?.data ?? [],
      totalDocuments: response?.metaData?.totalDocuments ?? 0,
    },
  })),
  on(editSubscriptionPlan, (state, payload: any) => ({
    ...state,
    data: {
      ...state.data,
      data: payload,
    },
  })),
  on(deleteSubscriptionPlan, (state, { payload }) => ({
    ...state,
    data: {
      ...state.data,
      data: state.data.data.filter(
        (d: any) => !payload.includes(String(d._master))
      ),
      totalDocuments: state.data.totalDocuments - 1,
    },
  })),
  on(paginateSubscriptionPlans, (state) => state)
);

export function reducer(state: any, action: Action): any {
  return subscriptionPlansReducer(state, action);
}
